module.exports = __webpack_public_path__ + "img/energyfinders.d17f0ba2.png";